import { render } from "./SolarChart.vue?vue&type=template&id=37d1b130"
import script from "./SolarChart.vue?vue&type=script&lang=js"
export * from "./SolarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__